// src/pages/Dashboard.js
import { useEffect, useState } from 'react';
import axios from '../api/axios';
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import Departments from './Departments';
import { Users, Building2 } from 'lucide-react'; // Add icons for visual appeal

export default function Dashboard() {
  const [deptCount, setDeptCount] = useState(0);
  const [empCount, setEmpCount] = useState(0);
  const navigate = useNavigate();

  const orgId = useAuthStore((state) => state.orgId);
  const access = useAuthStore((state) => state.access);

  useEffect(() => {
    if (!access) {
      alert('Unauthorized access. Please log in.');
      navigate('/');
    } else if (orgId) {
      fetchCounts();
    }
  }, [orgId, access]);

  const fetchCounts = async () => {
    try {
      const deptRes = await axios.get(`/api/departments/?organization=${orgId}`);
      setDeptCount(deptRes.data.length);

      const empRes = await axios.get(`/api/employees/?organization=${orgId}`);
      setEmpCount(empRes.data.length);
    } catch (error) {
      console.error('Dashboard fetch error:', error);
      if (error.response?.status === 401) {
        alert('Session expired or unauthorized. Please log in again.');
        navigate('/');
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-blue-50 flex items-center justify-center p-4">
      <div className='hidden'>
        <Departments />
      </div>

      <div className="bg-white shadow-2xl rounded-3xl p-10 w-full max-w-xl transition-all duration-500 hover:shadow-blue-200">
        <h2 className="text-4xl font-extrabold text-center text-blue-700 mb-10">📊 Dashboard</h2>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 mb-10">
          <div className="flex items-center justify-center space-x-4 bg-blue-50 p-6 rounded-2xl shadow hover:shadow-md transition">
            <Building2 className="text-blue-600 w-8 h-8" />
            <div>
              <p className="text-lg text-gray-600">Departments</p>
              <p className="text-2xl font-bold text-blue-700">{deptCount}</p>
            </div>
          </div>
          <div className="flex items-center justify-center space-x-4 bg-green-50 p-6 rounded-2xl shadow hover:shadow-md transition">
            <Users className="text-green-600 w-8 h-8" />
            <div>
              <p className="text-lg text-gray-600">Employees</p>
              <p className="text-2xl font-bold text-green-700">{empCount}</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
          <Link
            to="/departments"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl text-center shadow-lg transition-all"
          >
            View Departments
          </Link>
          <Link
            to="/employees"
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-xl text-center shadow-lg transition-all"
          >
            View Employees
          </Link>
        </div>
      </div>
    </div>
  );
}
